var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnooze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.875V27.125M12.9166 5.16667L15.5 7.75L18.0833 5.16667M12.9166 25.8333L15.5 23.25L18.0833 25.8333M5.46655 9.6875L25.6016 21.3125M5.31046 12.2823L8.48646 11.4313L7.63546 8.25524M23.4321 22.7448L22.581 19.5687L25.7571 18.7178M25.6015 9.6875L5.46632 21.3125M23.4325 8.25524L22.5816 11.4313L25.7575 12.2823M5.31088 18.7177L8.4869 19.5687L7.63588 22.7447",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnooze);
export default __webpack_public_path__ + "static/media/snooze.5cff2956cee36cc129b381637247ea13.svg";
export { ForwardRef as ReactComponent };